import { get } from "lodash";
import { getLocalStorageItem } from "../helper/localStorageHelper";
import { subscribeRuntimeContext } from "./runtimeAccessor";

const computeDerived = () => {
  const userMetadataValue = getLocalStorageItem("user");
  const snopValue = getLocalStorageItem("snop");
  const selectedBusinessUnitValue = getLocalStorageItem("selected_business_unit");

  return {
    userMetadataValue,
    selectedBusinessUnitValue,
    buIdValue: selectedBusinessUnitValue?.business_unit_id || null,
    tenantIdValue: userMetadataValue?.tenant_id || null,
    customPermissionsValue: userMetadataValue?.custom_permissions || {},
    snopIdValue: snopValue?.snop_id || null,
    firstNameValue: get(userMetadataValue, "first_name", ""),
    lastNameValue: get(userMetadataValue, "last_name", ""),
    businessUnitNameValue: selectedBusinessUnitValue?.business_unit_name,
    userRoleValue: get(userMetadataValue, "roles", []),
    businessUnitsValue: get(userMetadataValue, "business_units") || [],
    userIdValue: userMetadataValue?.user_id || null,
  };
};

let derived = computeDerived();

subscribeRuntimeContext(() => {
  derived = computeDerived();
});

// Live runtime snapshot. Exported as a single `const` object with getters
// (rather than reassigned `export let` bindings — SonarQube S6861 "exporting
// mutable let binding") so every consumer still reads the latest value on each
// access via `appState.<field>`; the getters delegate to the internal (non
// exported) `derived` cache that subscribeRuntimeContext refreshes above.
export const appState = {
  get user_metadata() { return derived.userMetadataValue; },
  get selected_business_unit() { return derived.selectedBusinessUnitValue; },
  get buId() { return derived.buIdValue; },
  get tenantId() { return derived.tenantIdValue; },
  get custom_permissions() { return derived.customPermissionsValue; },
  get snopId() { return derived.snopIdValue; },
  get firstName() { return derived.firstNameValue; },
  get lastName() { return derived.lastNameValue; },
  get businessUnitName() { return derived.businessUnitNameValue; },
  get userRole() { return derived.userRoleValue; },
  get business_units() { return derived.businessUnitsValue; },
  get userId() { return derived.userIdValue; },
};
